import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NotFoundScreen } from '../../components/alliance/system-screens';
import { RouteContainer } from '../../components/route-container';

/**
 * Unknown routes render the 404 inside the shell (bar and sidebar stay
 * usable) instead of silently redirecting home.
 */
export function NotFound() {
  // Hooks
  const navigate = useNavigate();

  return (
    <RouteContainer routeTitle="Page not found" noanimation>
      <NotFoundScreen onHome={() => navigate('/home')} />
    </RouteContainer>
  );
}
